import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


Vue.config.productionTip = false

import VueNotification from "@kugatsu/vuenotification";
Vue.use(VueNotification, {dark: {background: "#117A8B", color: "#FFFFFF"}});



//import Tooltip from './utils/ToolTip/Tooltip.vue';
//Vue.component('Tooltip', Tooltip);

import Tooltip from './utils/ToolTip/Tooltip.js';
import '@/assets/tooltip.css';
Vue.directive('tooltip', Tooltip);

import NotificadorPlugin from './utils/Notificaciones/notificador.js';
Vue.use(NotificadorPlugin, {
 estiloGlobal: {
    success: { background: '#dff0d8', color: '#3c763d', marcaColor: '#3c763d' },
    error: { background: '#f2dede', color: '#a94442', marcaColor: '#a94442' },
    info: { background: '#d9edf7', color: '#31708f', marcaColor: '#31708f' },
    warning: { background: '#fff3cd', color: '#856404', marcaColor: '#ff9800' },
    custom: { background: '#e3f2fd', color: '#0d47a1', marcaColor: '#a94442' },
    asdasdasdasd: { background: 'blue', color: 'white', marcaColor: 'darkblue' }
  }
});

/**
 * 
 * @param {int} tipo "1-success, 2-warning, 3-error, (Cualquier Otro)-info" 
 * @param {string} mensaje "Mensaje de la notificacion"
 * @param {int} tiempo "Tiempo de duracion de la notificacion en segundos"
 */
Vue.prototype.mostrarNotificaciones = function (tipo, mensaje, tiempo=10, position="bottom-left") {

    /*this.$notificar("info asassadddd asd asdasdasd asdasd ",
         {
            tipo: "info",
            time: 10000,
            position: "bottom-left"
         }
    );

    this.$notificar("error asdasd", 
        {
            tipo: "personal",
            time: 10000,
            position: "bottom-right",
            customStyle: { background: "red", color: "yellow", marcaColor: 'blue' }
         });
    this.$notificar("success", {
            tipo: "success",
            time: 10000,
            position: "bottom-center",
         });

        this.$notificar("Hubo un error success", {
            tipo: "success",
            time: 10000,
            position: "top-left",
            customStyle: { background: "blue", color: "yellow", marcaColor: 'red' },
        });
    this.$notificar("Hubo un error success", {
            tipo: "success",
            time: 10000,
            position: "top-left",
            customStyle: { background: "red", color: "yellow", marcaColor: 'blue', borderRadius: '16px' },
            customContainerStyle: { top: "100px" }
         });
         */
    //
    //this.$notificar("Hubo un error", "success", 10000, "top-left");
    //this.$notificar("Hubo un error", "success", 10000, "top-right");
    //this.$notificar("Hubo un error", "success", 10000, "top-center");
    //this.$notificar("Hubo un error", "success", 10000, "top-center");
    //this.$notificar("Hubo un error", "success", 10000, "top-center");
    //this.$notificar("Hubo un error", "personalizado", 10000, "bottom-left");
    
    //this.$notificar("Solo mensaje");
    
    var propiedadesNotificaciones = {
        tipo: "info",
        time: tiempo * 1000,
        position: position,
    }
    if(tipo == 1){
        propiedadesNotificaciones.tipo = "success";
        this.$notificar(mensaje, propiedadesNotificaciones);
    }
    else if(tipo == 3){
        propiedadesNotificaciones.tipo = "error";
        this.$notificar(mensaje, propiedadesNotificaciones);
    }
    else if(tipo == 2){
        propiedadesNotificaciones.tipo = "warning";
        this.$notificar(mensaje, propiedadesNotificaciones);
    }
    else{
        this.$notificar(mensaje, propiedadesNotificaciones);
    } 
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
